export default __webpack_public_path__ + "static/media/learning-strategy.1d434d5b.svg";